import { useSyncExternalStore } from "react";

const listeners = new Set();
const getSnapshot = () => (localStorage.getItem("loi-theme") === "dark" ? "dark" : "light");
const subscribe = (l) => {
  listeners.add(l);
  return () => listeners.delete(l);
};

export const toggleTheme = () => {
  const next = getSnapshot() === "light" ? "dark" : "light";
  if (next === "light") localStorage.removeItem("loi-theme");
  else localStorage.setItem("loi-theme", next);
  listeners.forEach((l) => l());
};

export const useTheme = () => useSyncExternalStore(subscribe, getSnapshot);
